import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: 'Import jest prawie gotowy!',
      description: 'Kliknij przycisk Dalej, aby zakończyć import',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Niektóre dane w pliku są brakujące lub mają nieprawidłowy format',
      description:
        'Napraw błędy poniżej i prześlij plik ponownie lub kliknij Dalej, aby zignorować nieprawidłowe wiersze/komórki',
    },
    [ValidationStatus.Invalid]: {
      title: 'Przesłanego pliku nie można przetworzyć',
      description: 'Napraw błędy poniżej i spróbuj ponownie',
    },
  },
  sections: {
    heading_validation: {
      title: 'Wykryto niezgodność nazw/kolejności kolumn:',
      rules: {
        Exact: 'Kolumna #{{column}} musi istnieć i nosić dokładnie nazwę <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Wykryto następujące błędy:',
      labels: {
        row: 'Wiersz <strong>#{{row}}:</strong>',
        imported_rows_one: '{{count}} wiersz zostanie zaimportowany',
        imported_rows_few: '{{count}} wiersze zostaną zaimportowane',
        imported_rows_many: '{{count}} wierszy zostanie zaimportowanych',
        imported_rows_other: '{{count}} wiersze/wierszy zostanie zaimportowanych',
        ignored_rows_one: '{{count}} wiersz zostanie pominięty',
        ignored_rows_few: '{{count}} wiersze zostaną zignorowane',
        ignored_rows_many: '{{count}} wierszy zostanie zignorowanych',
        ignored_rows_other: '{{count}} wiersze/wierszy zostanie pominiętych',
      },
      fields: {
        email: 'E-mail',
        phone_number: 'Numer telefonu',
        first_name: 'Imię',
        last_name: 'Nazwisko',
        birthday: 'Data urodzenia',
      },
      rules: {
        Required: 'Pole {{field}} jest wymagane. Wiersz zostanie pominięty',
        Email: 'Pole {{field}} musi być prawidłowym adresem e-mail. Wiersz zostanie pominięty',
        Phone: 'Pole {{field}} musi być numerem telefonu w formacie międzynarodowym. Pole zostanie pominięte',
        Date: 'Pole {{field}} musi być prawidłową datą. Pole zostanie pominięte',
      },
    },
  },
  buttons: {
    back_to_upload: 'Wróć do przesyłania',
    proceed: 'Dalej',
  },
  toasts: {
    error: 'Coś poszło nie tak, prosimy skontaktować się z pomocą techniczną',
  },
};
